import { Component, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: true,
    imports: [NgStyle]
})
export class SpinnerComponent {
  @Input() styleRules: string;
  @Input() small: boolean = false;

  constructor() { }

}
